module.exports = __webpack_public_path__ + "img/page-under-construction-dark.d2220362.svg";